export class DatasimPrincing {
    type: String;
    productOption: String;
    costMonthly: number;
    costUnique: number;

    static PRICE_VOICE_OPTION = 1200;
  
    constructor() {
      this.type = '';
      this.productOption = '';
      this.costUnique = 0;
      this.costMonthly = 0;
    }
}


// WEBPACK FOOTER //
// ./src/models/DatasimPricing.ts